export enum NotifyType {
  User = 'user',
  System = 'system',
}
